import axios from 'axios';
let baseURL = ''
import { Message } from 'element-ui'
import $router from '../router'
// if (process.env.NODE_ENV === 'production') {
//   if (window.location.origin.indexOf('ai.drugflow.com') > -1) {
//     baseURL = 'https://ai-api.drugflow.com/';
//   }else{
//     baseURL = 'https://ai-api.drugflow.com/';

//   }
// } else {
//   baseURL = '';
// }
// 提示时长
const time = 5000
const instance = axios.create({
  baseURL,
  headers: {
    'content-type': 'application/json',
  },
  withCredentials: true
})
// 请求拦截器
// 设置axios请求头加入token
instance.interceptors.request.use(
  config => {
    // config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['token'] = localStorage.getItem('logintoken') || ''
    // FormData 交给浏览器自动带 boundary，避免写死 multipart/form-data 导致后端解析失败
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      if (config.headers) {
        delete config.headers['Content-Type']
        delete config.headers['content-type']
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  response => {
    if(response.data.code == 401){
      if (!response.config.silent) {
        Message.error('请求未经授权，需要提供有效的身份验证凭证')
        localStorage.removeItem("logintoken")
        $router.push({ path: '/login' })
      }
    }
    return response.data
  },
  error => {
   if (error.config && error.config.silent) {
     return Promise.reject(error)
   }
   if (error.response.status === 401) {
      Message.error('请求未经授权，需要提供有效的身份验证凭证')
      localStorage.removeItem("logintoken")
      $router.push({ path: '/login' })
    }else if (error.response && [404, 403, 500, 400, 422].includes(error.response.status)) {
      const data = error.response.data || {}
      const msg = data.msg || data.message || '请求失败'
      Message.error(msg)
    }
    return Promise.reject(error)
  }
)

export default instance

// // 登录请求方法
// const loginreq = (method, url, params) => {
//     return axios({
//         method: method,
//         url: url,
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         data: params,
//         traditional: true,
//         // transformRequest: [
//         //     function(data) {
//         //         let ret = ''
//         //         for (let it in data) {
//         //             ret +=
//         //                 encodeURIComponent(it) +
//         //                 '=' +
//         //                 encodeURIComponent(data[it]) +
//         //                 '&'
//         //         }
//         //         return ret
//         //     }
//         // ]
//     }).then(res => res.data);
// };
// 通用公用方法
// const req = (method, url, params) => {
//     return axios({
//         method: method,
//         url: url,
//         headers: {
//             'Content-Type': 'application/json',
//             token: localStorage.getItem('logintoken')
//         },
//         data: params,
//         traditional: true,
//         transformRequest: [
//             function(data) {
//                 let ret = ''
//                 for (let it in data) {
//                     ret +=
//                         encodeURIComponent(it) +
//                         '=' +
//                         encodeURIComponent(data[it]) +
//                         '&'
//                 }
//                 return ret
//             }
//         ]
//     }).then(res => res.data);
// };

// export {
//     loginreq,
//     req
// }




// WEBPACK FOOTER //
// ./src/api/axiosFun.js